import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { brandsRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {brandsRoutes.map((prop, key) => {
      if (prop.layout === 'brand') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/brand" to="/brand-list" />
  </Switch>
);

const Pills = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Pills;
